export interface AuthState {
  isLoggedIn: boolean;
  token: string | null;
  currentUser: {
    email: string;
    picture: string | null;
  };
}

// Safe function to get initial state - handles cases where localStorage might not be available
function getInitialState(): AuthState {
  try {
    const token =
      typeof window !== 'undefined' && window.localStorage
        ? localStorage.getItem('cassa.jwttoken')
        : null;

    return {
      isLoggedIn: !!token,
      token: token,
      currentUser: {
        email: 'mail@example.com',
        picture: null,
      },
    };
  } catch (error) {
    // If localStorage is not available (SSR, etc.), return default state
    return {
      isLoggedIn: false,
      token: null,
      currentUser: {
        email: 'mail@example.com',
        picture: null,
      },
    };
  }
}

export const initialState: AuthState = getInitialState();
